import posthog from 'posthog-js';

export function initPostHog() {
  if (typeof window === 'undefined') return;
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    console.warn('[PostHog] NEXT_PUBLIC_POSTHOG_KEY not set — tracking disabled');
    return;
  }

  console.log('[PostHog] init key:', process.env.NEXT_PUBLIC_POSTHOG_KEY ? '✓ present' : '✗ missing', '| host:', process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com (default)');
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    loaded: (ph) => {
      // ph.debug();
    },
  });
}

export interface RestaurantContext { id?: string | null; name?: string | null; slug?: string | null }

/**
 * Tag everything this visitor does from now on with the restaurant: registers restaurant_id / restaurant_name /
 * restaurant_slug on every later event (pageviews, clicks, order_placed, ...) and joins the PostHog "restaurant" group
 * so Group analytics is named after the restaurant. Call it where the restaurant is known (storefront, feedback page, admin).
 */
export function setRestaurantContext(r: RestaurantContext) {
  if (typeof window === 'undefined' || !r.id) return;
  posthog.register({ restaurant_id: r.id, restaurant_name: r.name ?? undefined, restaurant_slug: r.slug ?? undefined });
  posthog.group('restaurant', r.id, { name: r.name ?? undefined, slug: r.slug ?? undefined });
}

export function clearRestaurantContext() {
  if (typeof window === 'undefined') return;
  posthog.unregister('restaurant_id');
  posthog.unregister('restaurant_name');
  posthog.unregister('restaurant_slug');
  posthog.resetGroups();
}

export { posthog };
